import { useAuth0 } from '@auth0/auth0-react'
import { useQuery } from '@tanstack/react-query'
import { requestGET } from '../services/request'

export interface PipelineModelInput {
  name: string
  map_from?: string
  datatype: string
  shape: number[]
}

// Mirrors krane-infer's PipelineWindowSummary (see its src/api.rs) - mode discriminates which of
// the two groups of fields is populated, same as the WindowSpec config it's derived from.
export interface PipelineWindowSummary {
  mode: 'count' | 'time'
  length?: number
  stride?: number
  length_ms?: number
  stride_ms?: number
  lateness_ms?: number
}

// Called "pipelines" on krane-infer (see its src/api.rs) - shown as "Models" in this app, since
// that's what they represent to everyone but the pipeline's own author.
export interface PipelineSummary {
  name: string
  title: string
  description?: string
  version?: string
  organization_name: string
  type: string
  model_name: string
  model_version?: string
  inputs: PipelineModelInput[]
  window?: PipelineWindowSummary
}

export const usePipelines = () => {
  const auth = useAuth0()
  return useQuery<PipelineSummary[]>({
    queryKey: ['pipelines'],
    queryFn: async () => requestGET(`infer/pipelines`, undefined, auth),
  })
}
